
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9ca4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9ca4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ca3Iw = parcelRequire("ca3Iw");

var $blj7V = parcelRequire("blj7V");
document.addEventListener("DOMContentLoaded", ()=>{
    const latestBlog = (0, $blj7V.BLOG_DOCUMENTS)[0];
    const clientService = (0, $ca3Iw.ComponentDependencyTree).clientService;
    const template = `
<style>
    .blog-info-container {
        border: 1px solid var(--body-color);
        border-radius: 10px;
        padding: 1em;
        cursor: pointer;
        margin-bottom: 1em;
    }

    .blog-info-container:hover {
        background-color: var(--input-border-color);
    }

    .blog-info {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 1em;
        padding-bottom: 1em;
    }

    .blog-img {
        align-self: center;
        --width: auto;
        --max-width: 100%;
        --max-height: 15em;
    }

    .blog-title {
        text-align: center;
        font-size: 1.3em;
    }
</style>
<div class="blog-info">
    ${latestBlog.metadata.meta_img ? `<img-smart class="blog-img" src="${latestBlog.metadata.meta_img}"></img-smart>` : ``}
    <h3 class="blog-title">${latestBlog.metadata.meta_title}</h3>
    <div>
        <p><b>Date: </b>${latestBlog.metadata.date_created}</p>
        <p><b>Description: </b>${latestBlog.metadata.meta_description}</p>
    </div>
</div>
    `;
    document.getElementById("blog-info-container").innerHTML = template;
    document.getElementById("blog-info-container").addEventListener("click", ()=>{
        console.log("[MoreLatestBlog] path opening", latestBlog.path);
        const updatedUrl = clientService.createLocalLink("blog/" + latestBlog.path, {}, true);
        console.log("[MoreLatestBlog] navigating", updatedUrl);
        window.location.href = updatedUrl;
    });
});


//# sourceMappingURL=more.bd9762f1.js.map
